const regionalSites = {
	'de-DE': {
		href: 'https://de.audionetwork.com',
		language: 'Deutsch',
		region: 'Deutschland',
		label: null,
	},
	'en-GB': {
		href: 'https://www.audionetwork.com',
		language: 'English',
		region: 'United Kingdom',
		label: null,
	},
	'en-US': {
		href: 'https://us.audionetwork.com',
		language: 'English',
		region: 'United States',
		label: null,
	},
	'en-AU': {
		href: 'https://au.audionetwork.com',
		language: 'English',
		region: 'Australia',
		label: null,
	},
	'es-ES': {
		href: 'https://es.audionetwork.com',
		language: 'Español',
		region: 'España',
		label: null,
	},
	'fr-FR': {
		href: 'https://fr.audionetwork.com',
		language: 'Français',
		region: 'France',
		label: null,
	},
	'it-IT': {
		href: 'https://it.audionetwork.com',
		language: 'Italiano',
		region: 'Italia',
		label: null,
	},
	'pt-PT': {
		href: 'https://pt.audionetwork.com',
		language: 'Português',
		region: 'Portugal',
		label: null,
	},
	'ja-JP': {
		href: 'https://jp.audionetwork.com',
		language: '日本語',
		region: '日本',
		// Add aria labels for JP and CN because screen readers can't always read JP/CN scripts
		label: '日本語 日本 Nihongo (Nihon)',
	},
	'zh-CN': {
		href: 'https://cn.audionetwork.com',
		language: '简体中文',
		region: '中国',
		label: '简体中文 中国 Jiǎntǐ zhōngwén (Zhōngguó)',
	},
}

export default regionalSites
